import FactManagementPage from "@/features/facts/components/FactManagementPage";

export default function SleepExerciseFactsPage() {
  return (
    <FactManagementPage
      section="sleep-exercise"
      type="sleep"
      title="Sleep & Exercise Facts Management"
      description="Manage all the sleep facts in one place."
    />
  );
}
